export default __webpack_public_path__ + "static/media/benefit_9@3x.ba87f90d.png";